// Copyright (c) Hamilton Manufacturing Corp.
import { useEffect, useState } from 'react';

const Counter = ({ to, duration = 500, ...props }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        const countTo = parseInt(to, 10);
        const easeOutQuad = t => t * (2 - t);
        const frameDuration = 1000 / 60;

        let frame = 0;
        const totalFrames = Math.round(duration / frameDuration);
        const counter = setInterval(() => {
            frame++;
            const progress = easeOutQuad(frame / totalFrames);
            setCount(countTo * progress);

            if (frame === totalFrames) {
                clearInterval(counter);
            }
        }, frameDuration);
    }, [to]);

    return Math.floor(count).toLocaleString();
}

export default Counter;
